/** Timings, shortened under test so the suite doesn't wait on animations. */
const TEST = import.meta.env.MODE === "test";

export const TIMING = {
  /** Autosave: wait this long after the last keystroke. */
  saveDebounceMs: TEST ? 30 : 600,
  /** First retry of a failed save; doubles up to the max. */
  saveRetryMs: TEST ? 50 : 2000,
  saveRetryMaxMs: TEST ? 200 : 15000,
  /** Let the signature ink in before moving to the next screen. */
  inkMs: TEST ? 0 : 1300,
  /** "Thanks — you're verified" before the next screen. */
  verifiedMs: TEST ? 0 : 650,
  /** The wrong-code shake. */
  shakeMs: TEST ? 0 : 450,
  toastMs: 2800,
  /** Warn this long before the session lapses. */
  sessionWarnMs: 2 * 60_000,
} as const;
